import React, { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import DemoRequest from "../components/Demo/DemoRequest";
import Footer from "../components/Footer/Footer";
import OfficeTitle from "../components/Three/OfficeTitle";
import LoadingHome from "../components/Loading/LoadingHome";
import { Context } from "../context";

const DemoRequestPage = () => {
  const { debug, lang } = useContext(Context);
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");

  useEffect(() => {
    if (lang === "en") {
      setText("Demo request");
      setText2("Request a demo of some projects");
    } else if (lang === "it") {
      setText("Demo & Code");
      setText2("Richiedi la demo di alcuni progetti");
    }
  }, [lang]);

  return (
    <>
      <title>Davide Balice - Demo request</title>
      <LoadingHome />
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 1 }}
      >
        <OfficeTitle text={text} text2={text2} />
        <DemoRequest />
        <Footer />
      </motion.main>
    </>
  );
};

export default DemoRequestPage;
